import { Component } from "@kluntje/core";
import CookieService from "Services/CookieService";

/**
 * a component to handle the flight bookmark mechanism
 */
class FRAFlightBookmark extends Component {
  static readonly COOKIE_FLIGHT_BOOKMARK_HREFS = "fra-flight-bookmarks";

  flightBookmarks: string[];
  flightBookmarksCookie: any;
  separator: string;
  href: string;
  indexOfCurrentUrl: number;
  toggle: any;

  constructor() {
    super({
      ui: {
        flightBookmark: "#flight-bookmark :-one",
      },
      events: [
        {
          event: "change",
          target: "this",
          handler: "flightBookmarkUpdate",
        },
      ],
    });

    this.href = window.location.href;
    this.flightBookmarks = [];
    this.indexOfCurrentUrl = -1;
    this.separator = "; ";
    this.flightBookmarksCookie = CookieService.getCookie(FRAFlightBookmark.COOKIE_FLIGHT_BOOKMARK_HREFS);
  }

  /**
   * @override
   */
  afterComponentRender() {
    this.initFlightBookmark();
  }

  /**
   * call flight bookmark update function
   */
  flightBookmarkUpdate(): void {
    if (this.ui.flightBookmark.checked) {
      this.addBookmark();
    } else {
      this.removeBookmark();
    }
  }

  /**
   * call init flight bookmark function
   */
  initFlightBookmark(): void {
    if (this.readFlightBookmarkCookie() > -1) {
      this.ui.flightBookmark.checked = 1;
    } else {
      this.ui.flightBookmark.checked = 0;
    }
  }

  private addBookmark(): void {
    this.flightBookmarks.push(this.href);
    CookieService.setCookie(
      FRAFlightBookmark.COOKIE_FLIGHT_BOOKMARK_HREFS,
      this.flightBookmarks.filter(Boolean).join(this.separator),
      365,
    );
  }

  private removeBookmark(): void {
    const indexOfCurrentUrl = this.readFlightBookmarkCookie();
    this.flightBookmarks.splice(indexOfCurrentUrl, 1);
    CookieService.setCookie(
      FRAFlightBookmark.COOKIE_FLIGHT_BOOKMARK_HREFS,
      this.flightBookmarks.filter(Boolean).join(this.separator),
      365,
    );
  }

  /**
   * read flight bookmark cookie.
   * @returns {number} index of the current url in the cookie
   */
  readFlightBookmarkCookie(): number {
    this.flightBookmarksCookie = CookieService.getCookie(FRAFlightBookmark.COOKIE_FLIGHT_BOOKMARK_HREFS);
    if (
      CookieService.isCookieSet(FRAFlightBookmark.COOKIE_FLIGHT_BOOKMARK_HREFS) &&
      this.flightBookmarksCookie !== null
    ) {
      return this.flightBookmarksCookie.split(this.separator).indexOf(this.href, 0);
    }
    return -1;
  }
}

customElements.define("fra-m-flight-bookmark", FRAFlightBookmark);

export default FRAFlightBookmark;
